export { default } from './Surgeries';
